import { Box, WizardStep } from '@factorialco/deprecated-design-system'

import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import type { WizardData } from 'modules/processes/components/ItemWizard/Actions/types'
import { ActionConfigurationIdentifiers } from 'modules/processes/domain'
import { wizardConfiguredActions } from 'modules/processes/lib/wizardConfiguredActions'

interface Props {
  data: WizardData
  identifier: ActionConfigurationIdentifiers
  onDataChanged: (newData: WizardData) => void
}

const Preview = ({ data, identifier, onDataChanged }: Props) => {
  const components = wizardConfiguredActions()

  useUnsafeEffect(() => {
    onDataChanged({ ...data })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useUnsafeEffect(() => {
    onDataChanged({ ...data })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const Component = useUnsafeMemo(() => components[identifier]?.preview, [components, identifier])

  if (!Component) return null

  return (
    <Box paddingBottom="s24">
      <Component identifier={identifier} />
    </Box>
  )
}

export const previewInformationStep = (): WizardStep<WizardData> => ({
  title: i18n.t('processes.process_settings.actions.config.steps.preview'),
  nextText: i18n.t('processes.process_settings.actions.config.cta.create'),
  render: (props) =>
    props.data.action?.identifier && (
      <Preview
        identifier={props.data.action.identifier}
        data={props.data}
        onDataChanged={props.onDataChanged}
      />
    ),
  isCompleted: () => true,
})
